import React from "react";

export default (props) => {
  let estilo = { margin: 0 };
  if (props.style) {
    estilo = { ...estilo, ...props.style };
  }
  return (
    <button
      style={estilo}
      type={props.submit ? "submit" : "button"}
      className={`btn btn-block btn-lg btn${props.solid ? "" : "-outline"}-${props.type}`}
      onClick={props.event}
      disabled={props.disabled}
    >
      {props.icon && <i className={props.icon}></i>} {props.text}
    </button>
  );
};

/*
primary
secondary
success
danger
warning
info
light
dark
link
*/
